"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MfaTotpDisableRequestSchema", {
    enumerable: true,
    get: function() {
        return MfaTotpDisableRequestSchema;
    }
});
const _zod = require("zod");
const MfaTotpDisableRequestSchema = _zod.z.object({
    code: _zod.z.string().regex(/^\d{6}$/, 'code must be 6 digits')
}).strict();
